import { render } from "./AnnotationCanvas.vue?vue&type=template&id=ad00fd3c&scoped=true"
import script from "./AnnotationCanvas.vue?vue&type=script&lang=js"
export * from "./AnnotationCanvas.vue?vue&type=script&lang=js"

import "./AnnotationCanvas.vue?vue&type=style&index=0&id=ad00fd3c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad00fd3c"]])

export default __exports__